import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SquiggleItem } from '../types/types';
import './SideList.css';
import SideListNode from './SideListNode';

function SideList({
  extraClass,
  heading,
  icon,
  addPrepare,
  addClick,
  selectClick,
  items,
  showProperty,
  focus
} : {
  extraClass: string,
  heading: string,
  icon: IconDefinition,
  addPrepare: () => void,
  addClick: () => void,
  selectClick: (itemId: string) => void,
  items: SquiggleItem[],
  showProperty: keyof SquiggleItem,
  focus: () => void
}) {
  return <div className={"sidelist " + extraClass}>
    <div className="innercontainer">
      <div className="listheader" onClick={focus}>
        <span className="typeIcon">
          <FontAwesomeIcon icon={icon as IconProp} />
        </span>
        <span>{heading}</span>
        <div className="listadd" onMouseDown={addPrepare} onClick={(e) => { addClick(); e.stopPropagation(); }}>+</div>
      </div>
      <div className="itemcontainer">
        <ul>
          { items.filter(item => !item.parent || item.starred || item.archived)
              .map(item => <SideListNode key={item.id} items={items} item={item} selectClick={selectClick} showProperty={showProperty} />) }
        </ul>
      </div>
    </div>
  </div>;
}

export default SideList;